"use strict";

const _ = require('lodash');

const MIXINS = new Map();
function mix(superclass, ...mixins) {
	let r = superclass;
	for (let m of mixins) {
		if (!_.isFunction(m)) {
			m = MIXINS.get(m);
		}
		r = m(r);
	}
	return r;
}
mix.MIXINS = MIXINS;

module.exports = mix;